import styled from "styled-components";

export const LogoContainer = styled.div`
    background: #232c3b67;
    align-items: center;
    backdrop-filter: blur(0px);
    border: 4px solid rgba(255,255,255,0.1);
    border-radius: 16px;
    box-sizing: border-box;
    display: flex;
    height: 100%;
    justify-content: center;
    position: absolute;
    transition: 0.5s;
    width: 100%;

    &:hover {
        background: #232c3b;
        backdrop-filter: blur(10px);
        border: 12px solid rgba(255,255,255,0.1);
        transition: 0.5s;
    }

    h1 {
        color: #FFFFFF;
        font-size: 36px;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate(-50%, -50%);
    }
`

export const Background = styled.div`
    background-color: transparent;
    border-radius: 16px;
    height: 100%;
    opacity: 1.0;
    width: 100%;
`
